import React from 'react';
import VideoCallModal from './VideoCallModal';

const PatientVideoCallModal = ({ selectedTreatmentId, ...props }) => {
  return (
    <VideoCallModal
      {...props}
      workspaceVariant="patient"
      patientTreatmentId={selectedTreatmentId}
    />
  );
};

export default PatientVideoCallModal;
